import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { AuthService } from './auth.service';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { environment } from '@env/environment';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private authService: AuthService,
    private router: Router,
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (this.isInfanoApi(request.url)) {
      return this.getRequestWithToken(request).pipe(
        mergeMap((requestWithToken) =>
          next.handle(requestWithToken).pipe(
            catchError((err: unknown) => {
              if (err instanceof HttpErrorResponse) {
                if (err.status === 401 || err.status === 403) {
                  // Try to refresh token and retry request once
                  return this.authService.refreshForced().pipe(
                    mergeMap(() => this.getRequestWithToken(request)),
                    mergeMap((newRequestWithToken) => next.handle(newRequestWithToken)),
                    catchError((refreshErr) => {
                      this.authService.logout();
                      this.router.navigate(['/login']);
                      return throwError(() => refreshErr);
                    }),
                  );
                }
              }
              return throwError(() => err);
            }),
          ),
        ),
      );
    }
    return next.handle(request as HttpRequest<unknown>);
  }

  private isInfanoApi(url: string): boolean {
    return url.startsWith(environment.apiUrl);
  }

  private getRequestWithToken(request: HttpRequest<unknown>): Observable<HttpRequest<unknown>> {
    return this.authService.getToken().pipe(
      map((token) =>
        request.clone({
          setHeaders: { Authorization: `Bearer ${token}` },
        }),
      ),
    );
  }
}
